export default __webpack_public_path__ + "static/media/twitter.265833ce.png";